
export class ShowdownCardsVO {
    public index: number = 0;
    public c1: string;
    public c2: string;
}
